




























































































































































































































































































































import {
  LiveManagementCreateLivecarpItemRequest,
  LiveManagementCreateLivecarpRequest,
  LiveManagementEditLivecarpRequest,
  LiveManagementLivecarpDTO,
  LiveManagementLiveService,
  LiveManagementReadLiveCsvResponseApiRespoonse,
} from "@/common/api";
import { LANG } from "@/common/constant";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import { formatImageUrl } from "@/common/utils";
import CsvDropzoneComponent from "@/components/admin/live/common/csvDropzoneComponent.vue";
import LiveItemsComponent from "@/components/admin/live/common/liveItemsComponent.vue";
import LanguageComponent from "@/components/common/languageComponent.vue";
import QEditor from "@/components/common/qEditor.vue";
import QInputMultipleLanguage from "@/components/common/qInputMultipleLanguage.vue";
import QReleaseSettingLive from "@/components/common/qReleaseSettingLive.vue";
import QUploadSingleImage from "@/components/common/qUploadSingleImage.vue";
import {
  DEFAULT_IMAGE_KEYS,
  DEFAULT_IMAGES,
  DEFAULT_TIMEZONE,
} from "@/model/live";
import {
  camelCase,
  cloneDeep,
  isArray,
  isObject,
  keyBy,
  map,
  merge,
  omitBy,
  sortBy,
  transform,
  unionWith,
} from "lodash";
import capitalize from "lodash/capitalize";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const liveX = namespace("Live");

@Component({
  name: "LiveCreateComponent",
  components: {
    QEditor,
    QInputMultipleLanguage,
    QReleaseSettingLive,
    LanguageComponent,
    CsvDropzoneComponent,
    QUploadSingleImage,
    QErrors,
    LiveItemsComponent,
    QSearch,
    QPaginate,
    QCalendar,
    QTableHeader,
  },
})
export default class LiveCreateComponent extends Vue {

  get contentLanguageComputed() {
    if (this.languages[this.contentLanguage] === true) {
      return this.contentLanguage;
    } else {
      return "ja";
    }
  }

  get isDisableSubmitButtonComputed() {
    if (this.live.openStatus == "edit" || this.live.openStatus == "cancel") {
      return false;
    }
    const options = { timeZone: DEFAULT_TIMEZONE.timeZone };
    const currentDate = new Date(
      new Date().toLocaleString(DEFAULT_TIMEZONE.locale, options),
    );
    const endDatetime = new Date(this.live.endDatetime);
    return currentDate >= endDatetime;
  }

  get defaultThumbnailComputed() {
    return DEFAULT_IMAGES;
  }

  get currentImageComputed() {
    if (this.live.isUploadThumbnails) {
      return this.image?.name;
    } else {
      return this.defaultThumbnailComputed[this.live.thumbnailNo];
    }
  }

  get contextLangList() {
    const langEn = this.languages.en;
    const langCn = this.languages.cn;

    return [...[LANG.JA], ...(langEn ? ["en"] : []), ...(langCn ? ["cn"] : [])];
  }
  public title = "ライブ鯉の新規作成";

  public errors = {};
  public dateConfig = {
    enableTime: true,
    dateFormat: "Y-m-d H:i",
    defaultHour: 0,
  };

  public languages = {
    ja: true,
    en: true,
    cn: true,
  };

  public contentLanguage = LANG.JA;

  public live = {
    id: 0,
    title: "",
    titleEn: null,
    titleCn: null,
    startDatetime: null,
    endDatetime: null,
    isUploadThumbnails: false,
    imageId: null,
    thumbnailNo: DEFAULT_IMAGE_KEYS.IMAGE_1,
    context: "",
    contextEn: null,
    contextCn: null,
    postDate: null,
    openStatus: LiveManagementCreateLivecarpRequest.openStatus.EDIT,
    releaseSetting: LiveManagementCreateLivecarpRequest.releaseSetting.NOW,
    livecarpItems: [] as LiveManagementCreateLivecarpItemRequest[] | any[],
  };

  public isEditing = false;

  public uploading = false;

  public uploadOptions = {
    acceptedFiles: ".jpg, .jpeg, .png",
    maxFilesize: 5, // 5mb
  };

  public image = {
    id: null,
    name: null,
  };

  @liveX.Action
  public updateLive!: (live) => void;
  public imageUrl(name) {
    return formatImageUrl(name, "300x300");
  }

  public getDefaultThumbnailUrl(name) {
    return "/images/default/" + name;
  }

  public confirmDelete() {
    this.$modal.showDelete({
      text: `${this.$t("common.message.delete_confirm")}`,
      onConfirm: () => {
        this.delete();
      },
      onClose: () => {
        //
      },
    });
  }

  public confirmCancel() {
    this.$modal.showCancel({
      text: `${this.$t("common.message.cancel_confirm")}`,
      // we are passing callback method for our confirm button
      onConfirm: () => {
        this.$router.back();
      },
      onClose: () => {
        //
      },
    });
  }

  public async created() {
    const liveId = Number(this.$router.currentRoute.params.id);
    if (liveId) {
      this.isEditing = true;
      await this.getLive(liveId);
    }

    if (!this.live.titleCn && !this.live.contextCn) {
      this.languages.cn = false;
    }
  }

  public async submit() {
    this.errors = {};
    let result;

    if (this.live.isUploadThumbnails) {
      this.live.imageId = this.image.id;
    }
    this.live.livecarpItems = this.live.livecarpItems.filter(
      (item) => !item.isDeleted,
    );

    try {
      if (this.isEditing) {
        result = await LiveManagementLiveService.adminLiveEdit(this.live);
      } else {
        result = await LiveManagementLiveService.adminLiveCreate(this.live);
      }

      if (result.status == "success") {
        this.live.id = result.data.livecarp.id;
        this.isEditing = true;
        qNotify.success({
          text: this.$t("common.message.created"),
        });

        await this.$router.push({ name: "admin.live.index" });
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
        if ("context" in this.errors) {
          this.contentLanguage = LANG.JA;
        } else if ("contextEn" in this.errors) {
          this.contentLanguage = LANG.EN;
        } else if ("contextCn" in this.errors) {
          this.contentLanguage = LANG.CN;
        }
        (this.$refs.livecarpItems as any).getPageError(this.errors);
      }
    }
  }

  public async delete() {
    this.errors = {};

    try {
      const result = await LiveManagementLiveService.adminLiveDelete({
        id: this.live.id,
      });

      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });

        await this.$router.back();
      }
    } catch (error) {
      const result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      }
    }
  }

  public changeFile(file) {
    this.image.id = file ? file.id : null;
    this.image.name = file ? file.filePath : null;
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }
  public uploadStatus(flag) {
    this.uploading = flag;
  }

  public capitalizeLang(lang) {
    return capitalize(lang);
  }

  public changeCsv(result: LiveManagementReadLiveCsvResponseApiRespoonse) {
    const resultLive = omitBy(
      result.data.livecarp,
      (v) => v === "" || !v,
    ) as LiveManagementLivecarpDTO;
    this.live.title = resultLive.title || this.live.title;
    this.live.titleEn = resultLive.title_en || this.live.titleEn;
    this.live.titleCn = resultLive.title_cn || this.live.titleCn;
    this.live.startDatetime =
      resultLive.start_datetime || this.live.startDatetime;
    this.live.endDatetime = resultLive.end_datetime || this.live.endDatetime;
    this.live.context = resultLive.context || this.live.context;
    this.live.contextEn = resultLive.context_en || this.live.contextEn;
    this.live.contextCn = resultLive.context_cn || this.live.contextCn;
    const originalItems = this.live.livecarpItems;
    const items = keyBy(result.data.livecarp.livecarp_items, "code");
    this.live.livecarpItems = unionWith(
      this.live.livecarpItems,
      result.data.livecarp.livecarp_items,
      (a, b) => a.code === b.code,
    );
    delete result.data.livecarp.livecarp_items;

    map(this.live.livecarpItems, (row) => {
      if (items[row.code]) {
        const item = items[row.code];
        row = merge(
          row,
          this.convertObjectToCamelCase({
            ...omitBy(item, (v) => v === "" || !v),
          }),
        );
        const original = originalItems.find((row) => {
          return row.code === item.code;
        });
        row.status = original
          ? original.status
          : (item.status as LiveManagementCreateLivecarpItemRequest.status);
      }
    });

    this.live.livecarpItems = sortBy(this.live.livecarpItems, "code");
  }

  public preview() {
    this.updateLive(
      cloneDeep({
        ...this.live,
        image: {
          id: this.live.isUploadThumbnails
            ? this.image.id
            : this.live.thumbnailNo,
          name: this.currentImageComputed,
        },
      }),
    );
    window.open("/live/preview", "_blank");
  }

  public clearError(name) {
    this.errors = { ...this.errors, ...{ [name]: [] } };
  }

  public convertObjectToCamelCase(object) {
    return transform(object, (accumulator, value, key, target) => {
      const camelKey = isArray(target) ? key : camelCase(key as string);

      accumulator[camelKey] = isObject(value)
        ? this.convertObjectToCamelCase(value)
        : value;
    }) as any;
  }

  private async getLive(liveId) {
    const result = await LiveManagementLiveService.adminLiveView({
      id: liveId,
    });

    this.title = `${result.data.livecarp.title} の編集`;

    this.live.id = result.data.livecarp.id;
    this.live.title = result.data.livecarp.title;
    this.live.titleEn = result.data.livecarp.title_en;
    this.live.titleCn = result.data.livecarp.title_cn;
    this.live.startDatetime = result.data.livecarp.start_datetime;
    this.live.endDatetime = result.data.livecarp.end_datetime;
    this.live.isUploadThumbnails = result.data.livecarp.is_upload_thumbnails;
    this.live.imageId = result.data.livecarp.image_id;
    this.live.thumbnailNo = result.data.livecarp.thumbnail_no;
    if (this.live.isUploadThumbnails) {
      this.image = result.data.livecarp.image
        ? {
          id: result.data.livecarp.image.id,
          name: result.data.livecarp.image.name,
        }
        : {
          id: null,
          name: null,
        };
    }
    this.live.context = result.data.livecarp.context;
    this.live.contextEn = result.data.livecarp.context_en;
    this.live.contextCn = result.data.livecarp.context_cn;
    this.live.contextCn = result.data.livecarp.context_cn;
    this.live.openStatus = result.data.livecarp
      .open_status as LiveManagementEditLivecarpRequest.openStatus;
    this.live.releaseSetting = result.data.livecarp
      .release_setting as LiveManagementEditLivecarpRequest.releaseSetting;
    this.live.postDate = result.data.livecarp.post_date;

    for (const item of result.data.livecarp.livecarp_items) {
      this.live.livecarpItems.push({
        id: item.id,
        livecarpId: item.livecarp_id,
        code: item.code,
        isNarita: item.is_narita,
        producer: item.producer,
        producerEn: item.producer_en,
        producerCn: item.producer_cn,
        kind: item.kind,
        kindEn: item.kind_en,
        kindCn: item.kind_cn,
        ageId: item.age_id,
        sex: item.sex as LiveManagementCreateLivecarpItemRequest.sex,
        size: item.size,
        endTime: item.end_time,
        parent: item.parent,
        parentEn: item.parent_en,
        parentCn: item.parent_cn,
        startPrice: item.start_price,
        note: item.note,
        noteEn: item.note_en,
        noteCn: item.note_cn,
        status: item.status as LiveManagementCreateLivecarpItemRequest.status,
        isExtended: item.is_extended,
        isDeleted: false,
        images: item.images,
        title: result.data.livecarp.title,
        movie: item.movie,
        thumbnailUrl: item.thumbnailUrl,
      } as any);
    }
  }
}
